import React, { useImperativeHandle, forwardRef, useRef, useState } from 'react';
import { useDropdown } from './hooks/useDropdown';
const DropdownItem = forwardRef(function Button({ children, onClick, testId = 'store-dropdown-item', ...otherProps }, ref) {
    const { dropdownItemsRef, selectedDropdownItemIndexRef, close } = useDropdown();
    const [dropdownItemIndex, setDropdownItemIndex] = useState(0);
    const dropdownItemRef = useRef();
    const addToRefs = (el) => {
        if (el && !dropdownItemsRef?.current.includes(el)) {
            dropdownItemsRef?.current.push(el);
            setDropdownItemIndex(dropdownItemsRef?.current.findIndex((element) => element === el) ?? 0);
        }
        dropdownItemRef.current = el;
    };
    const onFocusItem = () => {
        selectedDropdownItemIndexRef.current = dropdownItemIndex;
        dropdownItemsRef?.current[selectedDropdownItemIndexRef.current]?.focus();
    };
    const handleOnClickItem = (event) => {
        onClick?.(event);
        close?.();
    };
    useImperativeHandle(ref, () => dropdownItemRef.current, []);
    return (React.createElement("button", Object.assign({ "data-store-dropdown-item": true, "data-testid": testId, ref: addToRefs, onFocus: onFocusItem, onMouseEnter: onFocusItem, onClick: handleOnClickItem, role: "menuitem", tabIndex: -1, "data-index": dropdownItemIndex }, otherProps), children));
});
export default DropdownItem;
//# sourceMappingURL=DropdownItem.js.map